var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1274_11880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.1533,
    y: 9,
    width: 39.5676,
    height: 36,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8657 18.2142H25.6514C25.7692 18.2142 25.8657 18.1178 25.8657 17.9999V18.2142H34.0085V17.9999C34.0085 18.1178 34.1049 18.2142 34.2228 18.2142H34.0085V20.1428H35.9371V17.9999C35.9371 17.0544 35.1683 16.2856 34.2228 16.2856H25.6514C24.7058 16.2856 23.9371 17.0544 23.9371 17.9999V20.1428H25.8657V18.2142ZM39.3657 20.1428H20.5085C20.0344 20.1428 19.6514 20.5258 19.6514 20.9999V21.8571C19.6514 21.9749 19.7478 22.0714 19.8657 22.0714H21.4835L22.1451 36.0803C22.188 36.9937 22.9433 37.7142 23.8567 37.7142H36.0174C36.9335 37.7142 37.6862 36.9964 37.729 36.0803L38.3907 22.0714H40.0085C40.1264 22.0714 40.2228 21.9749 40.2228 21.8571V20.9999C40.2228 20.5258 39.8398 20.1428 39.3657 20.1428ZM35.8112 35.7856H24.063L23.4148 22.0714H36.4594L35.8112 35.7856Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 25,
    x2: 28,
    y2: 33,
    stroke: "#00406A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 25,
    x2: 32,
    y2: 33,
    stroke: "#00406A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1274_11880",
    x: 0.15332,
    y: 0,
    width: 59.5674,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1274_11880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1274_11880",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletee);
export default __webpack_public_path__ + "static/media/deletee.91d0d6fa6706d5ab0df40d74ece0db32.svg";
export { ForwardRef as ReactComponent };